import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  useMediaQuery,
} from '@mui/material'
import React, { FC, useState } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'
import cn from '@/utils/cn'
import { Visibility, VisibilityOff } from '@mui/icons-material'

const s = cn('input-organization')

type IInput = {
  allowDecimal?: boolean
  maxDecimalPlaces?: number
}

type InputProps = TextFieldProps & IInput & UseControllerProps<any>

const Input: FC<InputProps> = ({
  name,
  control,
  allowDecimal,
  maxDecimalPlaces = 3,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const is4K = useMediaQuery('(min-width:2560px)')

  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields, errors },
  } = useController({
    name,
    control,
  })

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
  }
  const inputType =
    props.type === 'password'
      ? showPassword
        ? 'text'
        : 'password'
      : props.type === 'number'
        ? 'text'
        : props.type || 'text'

  const inputValue =
    props.type === 'number'
      ? field.value != null && field.value !== ''
        ? String(field.value)
        : ''
      : (field.value ?? '')

  return (
    <TextField
      {...field}
      {...props}
      value={inputValue}
      color='primary'
      className={s()}
      style={{ display: props.type === 'hidden' ? 'none' : '' }}
      autoComplete='new-password'
      variant='filled'
      sx={{}}
      size={is4K ? undefined : 'small'}
      margin='none'
      fullWidth
      type={inputType}
      error={!!errors[name]}
      helperText={errors[name]?.message as string}
      onChange={(e) => {
        if (props.type === 'number') {
          if (allowDecimal) {
            let value = e.target.value.replace(/[^0-9.,]/g, '')
            value = value.replace(',', '.')
            const parts = value.split('.')
            if (parts.length > 2) {
              value = parts[0] + '.' + parts.slice(1).join('')
            }
            if (parts.length === 2 && parts[1].length > maxDecimalPlaces) {
              value = parts[0] + '.' + parts[1].substring(0, maxDecimalPlaces)
            }
            field.onChange(value)
          } else {
            field.onChange(e.target.value.replace(/[^0-9]/g, ''))
          }
        } else {
          field.onChange(e.target.value)
        }
      }}
      InputProps={{
        endAdornment:
          props.type === 'password' ? (
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge='end'
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
        disableUnderline: true,
      }}
    />
  )
}

export default Input
